export default {
  title_1: '사용 설명서',
  operation_desc_1: '알루미늄 합금 쉘이 지갑을 손상으로부터 보호합니다',
  operation_desc_2: 'LEFT 버튼',
  operation_desc_3: '화면에서 왼쪽으로 이동하거나 이전 페이지로 돌아가기',
  operation_desc_4: 'DOWN 버튼',
  operation_desc_5: '화면에서 아래로 이동',
  operation_desc_6: '2인치 디스플레이: 관련 거래를 표시',
  operation_desc_7: 'UP 버튼',
  operation_desc_8: '화면에서 위로 이동',
  operation_desc_9: 'RIGHT 버튼',
  operation_desc_10: '화면에서 오른쪽으로 이동하거나 동작 확인',
  operation_desc_11: 'OK 버튼',
  operation_desc_12: '동작을 확인하거나 메뉴 페이지로 이동, 길게 눌러 전원 켜기/끄기',
  operation_desc_13: 'Type-C',
  operation_desc_14: '충전 및 펌웨어 업그레이드용',

  title_2: 'KeyPal 시작하기',
  get_start_desc_1: '초기화',
  get_start_desc_2: '"',
  get_start_desc_3: '" 버튼을 3초간 길게 눌러 전원을 켜면 KP_XXX 미활성화가 표시됩니다.',
  get_start_desc_4: '활성화 단계(지갑 생성):',
  get_start_desc_5: '1. 클릭하여',
  get_start_desc_6: '메인 메뉴로 들어갑니다.',
  get_start_desc_7: '2. 아래 버튼을 눌러',
  get_start_desc_8: '"Create Wallet"을 선택',
  get_start_desc_9: '3. 니모닉을 순서대로 백업 및 검증하고 PIN 코드를 설정하면 장치가 활성화됩니다.',
  get_start_desc_10: '기록은 펜과 종이나 KEYPAL 니모닉 박스를 사용하세요.',
  get_start_desc_11: '니모닉을 순서대로 기록하고 검증하세요',

  title_3: 'KeyPal을 TokenPocket에 연결하는 방법',
  connect_desc_1: '1. KeyPal의 Bluetooth가 켜져 있는지 확인: [설정]-[Bluetooth].',
  connect_desc_2: '2. TokenPocket에서 오른쪽 상단의 지갑 "',
  connect_desc_3: '"을 탭하고, "네트워크 선택" 페이지에서 KeyPal 하드웨어 지갑을 탭합니다.',
  connect_desc_4: '3. "장치 추가"를 선택합니다. TokenPocket이 장치를 검색하며, 현재 Bluetooth 이름과 일치하는 장치를 선택합니다.',
  connect_desc_4_2: '(알림: Bluetooth 이름은 [정보]-[장치 정보]에서 확인할 수 있습니다. 클라이언트에서 찾지 못할 경우, 하드웨어를 재시작하고 연결 단계를 반복하세요.',
  connect_desc_5: '연결에 성공하면 TokenPocket 자산 페이지 우상단에 KeyPal Bluetooth 아이콘이 표시됩니다.',
  connect_desc_6: '연결 성공',

  title_4: '지갑 일괄 생성',
  batch_desc_1: '1. Bluetooth로 KeyPal을 TokenPocket 앱에 연결합니다.',
  batch_desc_2: '2. 앱 우상단 Bluetooth 표시가 있는 하드웨어 지갑 아이콘을 탭합니다.',
  batch_desc_3: '3. "KeyPal 관리"로 들어가 "지갑 추가"를 탭합니다.',
  batch_desc_4: '4. 화면 우상단의 "일괄 추가"를 탭하면 완료됩니다.',
  batch_desc_5: 'KeyPal과 TokenPocket 연결 방법은 위 내용을 참고하세요',
  batch_desc_6: '일괄 지갑 보기',

  title_5: '교환, 이체 등 — PIN 코드로 서명',
  exchange_desc_1: 'KeyPal 하드웨어 지갑을 TokenPocket 앱에 연결하여 다음 작업을 수행합니다:',
  exchange_desc_2: '아래 이미지에서 첫 번째 행의 가장 오른쪽 이미지에 표시된 "*" 문자는 두 번째 행의 두 번째 이미지에 표시된 숫자와 대응합니다. KeyPal 장치에 표시되는 숫자에 따라 지갑 생성 시 설정한 PIN을 입력하면 됩니다.',
  exchange_desc_3: 'KeyPal에 표시되는 숫자 위치에 맞춰 클라이언트에서 입력하세요',

  tutorial_title_1: 'KeyPal 장치를 어떻게 인증하나요?',
  tutorial_desc_1: '장치 관리를 열어 장치 보안을 확인하세요.',
  tutorial_title_2: '내 주소가 KeyPal에 속하는지 확인하는 방법은?',
  tutorial_desc_2: 'KeyPal을 TokenPocket에 연결한 후 "Receive"와 "Test"를 순서대로 선택하세요.',
  tutorial_title_3: 'KeyPal로 토큰을 받는 방법',
  tutorial_desc_3: 'KeyPal을 TokenPocket에 연결하고 "Receive"를 선택하세요.',
  tutorial_title_4: 'KeyPal로 토큰을 보내는 방법',
  tutorial_desc_4: 'KeyPal을 TokenPocket에 연결하고 "Send"와 "Transfer"를 선택하세요.',
  tutorial_title_5: '거래 시 PIN 코드를 입력하는 방법은?',
  tutorial_desc_5: ''
};
